import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/shared/services/queryClient';
import {
  suppliersApi, type CreateSupplierRequest, type UpdateSupplierRequest,
} from '../services/suppliersApi';

export const useSuppliers = (enabled = true) => {
  return useQuery({
    enabled,
    queryKey: ['suppliers'],
    queryFn: suppliersApi.getAllSuppliers,
  });
};

export const useSupplierById = (id: string) => {
  return useQuery({
    queryKey: ['suppliers', id],
    queryFn: () => suppliersApi.getSupplierById(id),
  });
};

export const useCreateSupplier = () => {
  return useMutation({
    mutationFn: (payload: CreateSupplierRequest) =>
      suppliersApi.createSupplier(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
    },
  });
};

export const useUpdateSupplier = (id: string) => {
  return useMutation({
    mutationFn: (payload: UpdateSupplierRequest) =>
      suppliersApi.updateSupplier(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
      queryClient.invalidateQueries({ queryKey: ['suppliers', id] });
    },
  });
};

export const useDeleteSupplier = () => {
  return useMutation({
    mutationFn: (id: string) => suppliersApi.deleteSupplier(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
    },
  });
};